"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var Store_1 = require("owa-mail-store/lib/store/Store");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
/**
 * Moving and deleting items to/from Starred and Important folders should be blocked. We will show following message prompt to the user if these actions are performed on the client -
 * - Move/Delete from Important: “You can’t move or delete items from this folder”
 * - Move/Delete to Important:" You can’t move items to this folder"
 * - Move/Delete from Starred: “To remove an item from this folder, unflag it”
 * - Move to Starred: “To move an item to this folder, flag it”
 * @param sourceFolderId - Source folder id
 * @param destinationFolderId - Destination folder id
 * @returns true if the action was blocked, false otherwise
 */
function handleBlockActionForShadowMailbox(sourceFolderId, destinationFolderId) {
    if (!getUserConfiguration_1.default().SessionSettings.IsShadowMailbox) {
        return false;
    }
    var message;
    var mailStore = Store_1.getStore();
    var sourceFolder = mailStore.folders.folderTable.get(sourceFolderId);
    var destinationFolder = mailStore.folders.folderTable.get(destinationFolderId);
    var sourceFolderType = sourceFolder.sourceWellKnownFolderType;
    if (sourceFolderType == 87 /* Important */) {
        message = owa_mail_strings_1.default.blockActionFromImportantFolder;
    }
    else if (sourceFolderType == 88 /* Starred */) {
        message = owa_mail_strings_1.default.blockMoveDeleteFromStarredFolder;
    }
    else if (destinationFolder != null) {
        var destinationFolderType = destinationFolder.sourceWellKnownFolderType;
        if (destinationFolderType == 87 /* Important */) {
            message = owa_mail_strings_1.default.blockActionToImportantFolder;
        }
        else if (destinationFolderType == 88 /* Starred */) {
            message = owa_mail_strings_1.default.blockMoveToStarredFolder;
        }
    }
    if (message != undefined) {
        owa_confirm_dialog_1.confirm('', message, false, {
            hideCancelButton: true,
        });
        return true;
    }
    return false;
}
exports.default = handleBlockActionForShadowMailbox;
//# sourceMappingURL=handleBlockActionForShadowMailbox.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/helpers/handleBlockActionForShadowMailbox.js
// module id = 3468
// module chunks = 62